import { z } from 'zod'
import i18n from '@/lib/i18n'

const inspectionAnswerSchema = z.enum([
	'COMPLIANT',
	'NON_COMPLIANT',
	'NOT_APPLICABLE',
])
const inspectionStatusSchema = z.enum(['IN_PROGRESS', 'RESOLVED'])

const answersSchema = z
	.object({
		quizQuestionId: z.uuid('Invalid Question ID'),
		answer: inspectionAnswerSchema.optional(),
		// Preenchido só nos questionários de resposta livre (começa como string vazia)
		textAnswer: z.string().optional(),
		responsibleId: z.uuid('Invalid Question ID').optional(),
		dueDate: z
			.string()
			.refine((val) => !Number.isNaN(Date.parse(val)), 'Invalid date format')
			.optional(),
		actionPlan: z.string().optional(),
		status: inspectionStatusSchema.optional(),
		image: z.any().optional(),
		imagePath: z.string().optional(),
		removeImage: z.boolean().optional(),
	})
	.superRefine((data, ctx) => {
		if (data.textAnswer !== undefined) {
			if (!data.textAnswer.trim()) {
				ctx.addIssue({
					path: ['textAnswer'],
					code: z.ZodIssueCode.custom,
					message: i18n.t('form.directed.textAnswerError'),
				})
			}
			return
		}

		if (!data.answer) {
			ctx.addIssue({
				path: ['answer'],
				code: z.ZodIssueCode.custom,
				message: i18n.t('form.directed.answerError'),
			})
			return
		}

		if (data.answer === 'NON_COMPLIANT') {
			if (!data.responsibleId) {
				ctx.addIssue({
					path: ['responsibleId'],
					code: z.ZodIssueCode.custom,
					message: i18n.t('form.directed.responsibleError'),
				})
			}

			if (!data.dueDate) {
				ctx.addIssue({
					path: ['dueDate'],
					code: z.ZodIssueCode.custom,
					message: i18n.t('form.directed.dueDateError'),
				})
			}

			if (!data.actionPlan) {
				ctx.addIssue({
					path: ['actionPlan'],
					code: z.ZodIssueCode.custom,
					message: i18n.t('form.directed.actionPlanError'),
				})
			}

			if (!data.status) {
				ctx.addIssue({
					path: ['status'],
					code: z.ZodIssueCode.custom,
					message: i18n.t('form.directed.statusError'),
				})
			}
		}
	})

export const direcionadaSchema = z.object({
	date: z.string().refine((val) => !Number.isNaN(Date.parse(val)), {
		message: i18n.t('form.directed.dateError'),
	}),
	quizId: z.uuid(i18n.t('form.directed.quizIdError')),
	comment: z.string().optional(),
	answers: z.array(answersSchema).min(1, i18n.t('form.directed.answersError')),
})

// input (o que o form manda para o resolver)
export type DirecionadaInput = z.input<typeof direcionadaSchema>

// output (já validado)
export type DirecionadaFormData = z.output<typeof direcionadaSchema>
